module.exports = __webpack_public_path__ + "img/Efdot - Slider 04.2e4337d0.jpg";